export default __webpack_public_path__ + "static/media/14-EXT-(1-2).10000590.jpg";